import {initialState, NAME_SLICE} from "./constants";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IFactory} from "../../varibles/interface";

const factorySlice = createSlice({
    name: NAME_SLICE,
    initialState,
    reducers: {
        gets: (state) => {
            state.loading = true;
        },
        getsSuccess: (state, action: PayloadAction<IFactory[]>) => {
            state.loading = false;
            state.data = action.payload;
        },
        getsFailure: (state) => {
            state.loading = false;
        },
        getsByAdmin: (state) => {
            state.loading = true;
        },
        getsByAdminSuccess: (state, action: PayloadAction<IFactory[]>) => {
            state.loading = false;
            state.factoriesAdmin = action.payload;
        },
        getsByAdminFailure: (state) => {
            state.loading = false;
        },
        add: (state, action) => {
            const factory = action.payload;
            const {data} = state;
            state.data = [...data, factory];
        },
        update: (state, action) => {
            const factory = action.payload;
            const {data} = state;
            state.data = data.map(item => item.id === factory.id ? factory : item)
        },
        delete: (state, action) => {
            const id = action.payload;
            const {data} = state;
            state.data = data.filter(item => item.id !== id);
        },
    },
})

export const factoryActions = factorySlice.actions

const factoryReducer = factorySlice.reducer;

export default factoryReducer;
